import { expandedNameFieldsSortMap } from '@fs/zion-sls'

export function translateRelationshipChips(slsTypes, t) {
  return slsTypes?.relationships?.reduce((acc, cur) => {
    // eslint-disable-next-line no-warning-comments
    // TODO: Remove when SLS relationships are all translated.  Also remove the temp translations in the file
    const getRelLabel = (label) => t(`temp.relationship.${label}`, label)

    acc.push({
      value: `${cur.relType}_FIRST`,
      order: 'FIRST',
      relType: cur.relType,
      label: getRelLabel(cur.firstDisplayLabel),
    })
    if (cur.firstDisplayLabel !== cur.secondDisplayLabel) {
      acc.push({
        value: `${cur.relType}_SECOND`,
        order: 'SECOND',
        relType: cur.relType,
        label: getRelLabel(cur.secondDisplayLabel),
      })
    }
    return acc
  }, [])
}

export function translateEventFieldChips(slsTypes) {
  return (
    slsTypes?.fields?.reduce((acc, cur) => {
      if (
        cur.elementTypes?.includes('DATE') ||
        cur.elementTypes?.includes('PLACE') ||
        cur.elementTypes?.includes('EVENT')
      ) {
        acc.push({
          value: cur.fieldType,
          label: cur.displayLabel,
          elementTypes: cur.elementTypes,
        })
      }
      return acc
    }, []) || []
  )
}

export function translateAdditionalFieldChips(slsTypes) {
  return slsTypes?.fields?.reduce((acc, cur) => {
    if (cur.elementTypes?.includes('PERSON') && cur.fieldType !== 'RACE_OR_COLOR') {
      acc.push({
        value: cur.fieldType,
        label: cur.displayLabel,
      })
    }
    return acc
  }, [])
}

export function translateAgeFieldChips(slsTypes) {
  return slsTypes?.fields?.reduce((acc, cur) => {
    if (cur.elementTypes?.includes('AGE')) {
      acc.push({
        value: cur.fieldType,
        label: cur.displayLabel,
      })
    }
    return acc
  }, [])
}

export function translateNameElementChips(slsTypes) {
  // eslint-disable-next-line no-warning-comments
  // TODO: allow all name field types https://github.com/fs-webdev/shared-image-viewer/pull/1296/files#diff-df7b003d4e0034e23f94d789f8acb9750f0bd3bf334c0cc657312eb142ab4002R68
  const validNameFields = expandedNameFieldsSortMap
    .map((nameField) => nameField.fieldType)
    .reduce((acc, cur) => {
      const field = slsTypes?.fields?.find((f) => f?.fieldType === cur)
      acc.push({
        value: field?.fieldType || cur,
        label: field?.displayLabel || cur,
      })
      return acc
    }, [])

  return validNameFields
}
